import axios from "axios";

// Instancia propia, NO axios.defaults / Vue.prototype.$http (main.js): ese
// cliente compartido tiene un interceptor global que hace
// window.location.reload() ante un 403 sin "code" estructurado (sesión
// perdida) — ver errorHandler en main.js. Un poll de fondo (NotificationBell)
// no debe poder recargar la página sola en medio de un formulario si la
// sesión ya expiró en background; con esta instancia separada, un 403 del
// poll simplemente se ignora (ver NotificationBell.vue).
const client = axios.create({ withCredentials: true });

const base = () => `${String(process.env.VUE_APP_API_URL || "").replace(/\/$/, "")}/api/v1/notifications/me`;

export const notificationsApi = {
  getInbox({ page = 1, limit = 10, scope = "current", unreadOnly = false } = {}) {
    const params = new URLSearchParams({ page, limit, scope });
    if (unreadOnly) params.set("unread_only", "true");
    return client.get(`${base()}/inbox?${params.toString()}`).then((r) => r.data);
  },
  getUnreadCount() {
    return client.get(`${base()}/unread-count`).then((r) => r.data);
  },
  markRead(id) {
    return client.put(`${base()}/read/${id}`).then((r) => r.data);
  },
  markAllRead() {
    return client.put(`${base()}/read-all`).then((r) => r.data);
  },
};
